import { generateNavLink } from "../../utils/generateNavLink";
import { isBlackFridaySaleEnabled, isLunarNewYearEnabled } from "../helpers/outdoor";

const womensCollectionsMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead collection",
          text: data.Collection,
          dataPrefix: "women",
          dataLinkId: ["women", "collection"],
          tabIndex: 1,
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Collection,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "F24_Veilance_W_Nav",
              text: data["Veilance Name"],
              dataLinkId: ["women", "collection", "veilance"],
              blockArr: ["CN-block"],
              href: "/c/womens/veilance",
            })}
            ${generateNavLink({
              className: "professional-use",
              text: data["Professional Use"],
              dataPrefix: "women",
              dataLinkId: ["women", "collection", "professional-use"],
              href: "/c/womens/professional-use",
              blockArr: [],
            })}
            ${generateNavLink({
              className: "system_a",
              text: "System_A",
              dataPrefix: "woemn",
              dataLinkId: ["women", "collection", "system-a"],
              href: "/c/womens/system_a",
            })}
            ${generateNavLink({
              className: "SS24_WalkGently",
              text: "Walk Gently",
              dataLinkId: ["women", "collection", "walk-gently"],
              href: "/c/womens/walk-gently/wid-2jn408g9",
              blockArr: [
                "AT-block",
                "BE-block",
                "CZ-block",
                "DK-block",
                "FI-block",
                "FR-block",
                "DE-block",
                "GB-block",
                "IE-block",
                "IT-block",
                "NO-block",
                "PL-block",
                "ES-block",
                "SE-block",
                "CH-block",
                "NL-block",
                "CA-block",
                "US-block",
              ],
            })}
        </div>
    </ul>
`;

const womensClimbingMenu = data => `
    <ul>
        <div>
            ${generateNavLink({
              className: "sectionhead F24_ClimbingGear_W_Nav",
              text: data["Climbing Gear"],
              dataLinkId: ["women", "climbing-gear"],
              tabIndex: 1,
              href: "/c/womens/climbing-gear",
            })}
            <div class="mobilefly">
                ${generateNavLink({
                  className: "mobilehead",
                  text: data["Climbing Gear"],
                  dataPrefix: "women",
                })}
                ${generateNavLink({
                  className: "s23-climbing_gear_harness",
                  text: data["$^nav-harnesses^$"],
                  dataPrefix: "women",
                  dataLinkId: ["women", "climbing-gear", "harnesses"],
                  href: "/c/womens/climbing-gear/sub-cat=harnesses",
                })}
                ${generateNavLink({
                  className: "s23-climbing_gear_ropebags",
                  text: data["$^nav-chalkBags^$"],
                  dataPrefix: "women",
                  dataLinkId: ["women", "climbing-gear", "chalk-bags"],
                  href: "/c/womens/climbing-gear/sub-cat=chalk-bags",
                })}
            </div>
        </div>
    </ul>
`;

const womensFootwearMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_FTW_W_Nav",
          text: data.Footwear,
          dataLinkId: ["women", "footwear"],
          tabIndex: 1,
          href: "/c/womens/footwear",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Footwear,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "s23-ftw_boots",
              text: data["$^nav-boots^$"],
              dataPrefix: "women",
              href: "/c/womens/footwear/sub-cat=boots",
              dataLinkId: ["women", "footwear", "boots"],
            })}
            ${generateNavLink({
              className: "s23-ftw_shoes",
              text: data["$^nav-shoes^$"],
              dataPrefix: "women",
              href: "/c/womens/footwear/sub-cat=shoes",
              dataLinkId: ["women", "footwear", "shoes"],
            })}
        </div>
        <li class="spacer">
            <span>&nbsp;</span>
        </li>
    </ul>
`;

const womensClothingMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_WomensCollection_Nav",
          text: data.Clothing,
          dataLinkId: ["women", "clothing"],
          tabIndex: 1,
          href: "/c/womens",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Clothing,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "F24_ShellJackets_W_Nav",
              text: data["Shell Jackets"],
              dataLinkId: ["women", "clothing", "shell-jackets"],
              href: "/c/womens/shell-jackets",
            })}
            ${generateNavLink({
              className: "F24_InsulatedJackets_W_Nav",
              text: data["Insulated Jackets"],
              dataLinkId: ["women", "clothing", "insulated-jackets"],
              href: "/c/womens/insulated-jackets",
            })}
            ${generateNavLink({
              className: "F24_Pants_W_Nav",
              text: data.Pants,
              href: "/c/womens/pants",
              dataLinkId: ["women", "clothing", "pants"],
            })}
            ${generateNavLink({
              className: "F24_Fleece_W_Nav",
              text: data.Fleece,
              href: "/c/womens/fleece",
              dataLinkId: ["women", "clothing", "fleece"],
            })}
            ${generateNavLink({
              className: "F24_BaseLayer_W_Nav",
              text: data["Base Layer"],
              href: "/c/womens/base-layer",
              dataLinkId: ["women", "clothing", "base-layer"],
              blockArr: ["JP-block"],
            })}
            ${generateNavLink({
              className: "F24_ShirtsTops_W_Nav",
              text: data["Shirts & Tops"],
              href: "/c/womens/shirts-and-tops",
              dataLinkId: ["women", "clothing", "shirts-and-tops"],
            })}
            ${generateNavLink({
              className: "F24_Shorts_W_Nav",
              text: data.Shorts,
              href: "/c/womens/shorts",
              dataLinkId: ["women", "clothing", "shorts"],
              hide: true,
            })}
        </div>
    </ul>
`;

const womensPacksMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_Packs_W_Nav",
          text: data.Packs,
          dataLinkId: ["women", "packs"],
          tabIndex: 1,
          href: "/c/womens/packs",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Packs,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "s23_packs_daypack",
              text: data["$^nav-daypacks^$"],
              dataLinkId: ["women", "packs", "daypacks"],
              href: "/c/womens/packs/sub-cat=daypacks",
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "s23_packs_multiday",
              text: data["$^nav-multiDay^$"],
              dataLinkId: ["women", "packs", "multi-day"],
              href: "/c/womens/packs/sub-cat=multi-day",
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "s23_packs_travelcommute",
              text: data["$^nav-travelAndCommute^$"],
              dataPrefix: "women",
              dataLinkId: ["women", "packs", "travel-and-commute"],
              href: "/c/womens/packs/sub-cat=travel-and-commute",
            })}
              ${generateNavLink({
                className: "f24_packs_avalancheairbags",
                text: data["$^nav-avalancheAirbags^$"],
                dataPrefix: "women",
                dataLinkId: ["women", "packs", "avalanche-airbags"],
                href: "/c/womens/packs/sub-cat=avalancheairbags",
              })}
        </div>
    </ul>
`;

const womensAccessoriesMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_Accessories_W_Nav",
          text: data.Accessories,
          dataLinkId: ["women", "accessories"],
          tabIndex: 1,
          href: "/c/womens/accessories",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Accessories,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "F24_Gloves_Nav",
              text: data["$^nav-gloves^$"],
              dataLinkId: ["women", "accessories", "gloves"],
              href: "/c/womens/accessories/sub-cat=gloves",
            })}
            ${generateNavLink({
              className: "F24_ToquesBeanie_W_Nav",
              text: data["$^nav-toquesAndBeanies^$"],
              dataLinkId: ["women", "accessories", "toques-and-beanies"],
              href: "/c/womens/accessories/sub-cat=toques-and-beanies",
            })}
            ${generateNavLink({
              className: "F24_HatsCaps_Nav",
              text: data["$^nav-hatsAndCaps^$"],
              dataLinkId: ["women", "accessories", "hats-and-caps"],
              href: "/c/womens/accessories/sub-cat=hats-and-caps",
            })}
            ${generateNavLink({
              className: "F24_Socks_W_Nav",
              text: data.Socks,
              dataLinkId: ["women", "accessories", "socks"],
              href: "/c/womens/accessories/sub-cat=socks",
            })}
            ${generateNavLink({
              className: "s24_accessories_productcare",
              text: data["$^ProductCare^$"],
              dataLinkId: ["women", "accessories", "product-care"],
              href: "/c/womens/accessories/sub-cat=product-care",
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "s23_accessories_more",
              text: data["$^nav-more^$"],
              dataLinkId: ["women", "accessories", "more"],
              href: "/c/womens/accessories/sub-cat=more",
              dataPrefix: "women",
            })}
        </div>
    </ul>
`;

const womenActivityEvolutionClimb = data => `
    <ul class="activity-evolution-climb">
        ${generateNavLink({
          className: "sectionhead F24_AlpineRockClimb_W_Nav",
          href: "/c/womens/climb",
          text: data.Climbing,
          tabIndex: 1,
          dataLinkId: ["women", "climb"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Climbing,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "F24_AlpineClimb_W_Nav",
              text: data.Alpine,
              href: "/c/womens/climb/alpine",
              dataLinkId: ["women", "climb", "alpine"],
            })}
            ${generateNavLink({
              className: "F24_RockClimb_W_Nav",
              text: data.Rock,
              href: "/c/womens/climb/rock",
              dataLinkId: ["women", "climb", "rock"],
            })}
            ${generateNavLink({
              className: "F24_Bouldering_W_Nav",
              text: data.Boulder,
              href: "/c/womens/climb/boulder",
              dataLinkId: ["women", "climb", "boulder"],
            })}
        </div>
    </ul>
`;

const womenActivityEvolutionTrail = data => `
    <ul class="activity-evolution-trail">
        ${generateNavLink({
          className: "sectionhead F24_TrailRunning_W_Nav",
          href: "/c/womens/trail",
          text: data.Trail,
          tabIndex: 1,
          dataLinkId: ["women", "trail"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Trail,
              dataPrefix: "women",
            })}
            ${generateNavLink({
              className: "F24_RunMountain_W_Nav",
              text: data["Mountain Run"],
              href: "/c/womens/trail/mountain-run",
              dataLinkId: ["women", "trail", "mountain-run"],
            })}
            ${generateNavLink({
              className: "F24_HikeTrekk_W_Nav",
              text: data.Hike,
              href: "/c/womens/trail/hike",
              dataLinkId: ["women", "trail", "hike"],
            })}
            ${generateNavLink({
              className: "F24_EverydayEssentials_W_Nav",
              text: data.EverydayEvolution,
              href: "/c/womens/trail/everyday",
              dataLinkId: ["women", "trail", "everyday"],
            })}
        </div>
    </ul>
`;

const womenActivityEvolutionSki = data => `
    <ul class="activity-evolution-ski">
        ${generateNavLink({
          className: "sectionhead F24_SkiSB_W_Nav US-only remove-subcats",
          href: "/c/womens/ski-snowboard",
          text: data["Ski-and-Snowboard"],
          tabIndex: 1,
          dataLinkId: ["women", "ski-snowboard"],
        })}
        ${generateNavLink({
          className: "sectionhead F24_SkiSB_W_Nav US-block",
          href: "/c/womens/ski-snowboard",
          text: data["Ski-and-Snowboard"],
          tabIndex: 1,
          dataLinkId: ["women", "ski-snowboard"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead US-block",
              text: data["Ski-and-Snowboard"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBTouring_W_Nav US-block",
              text: data.Touring,
              href: "/c/womens/ski-snowboard/touring",
              dataLinkId: ["women", "ski-snowboard", "touring"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBFreeride_W_Nav US-block",
              text: data.Freeride,
              href: "/c/womens/ski-snowboard/freeride",
              dataLinkId: ["women", "ski-snowboard", "freeride"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBResort_W_Nav US-block",
              text: data.Resort,
              href: "/c/womens/ski-snowboard/resort",
              dataLinkId: ["women", "ski-snowboard", "resort"],
            })}
        </div>
    </ul>
`;

export const womensShopMoreMenu = (data, country) => `
    <ul class="shopmore">
        ${generateNavLink({
          className: "sectionhead shop-more",
          text: data["$^nav-ShopMore^$"],
          dataPrefix: "women",
          tabIndex: 1,
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data["$^nav-ShopMore^$"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more"],
            })}
            ${
              isBlackFridaySaleEnabled(country)
                ? generateNavLink({
                    className: "f23_blackfridaysale black-friday",
                    text: data["Black Friday Sale"],
                    dataPrefix: "women",
                    dataLinkId: ["sale", "black-friday-sale-womens"],
                    href: "/c/womens/p/black-friday-sale",
                  })
                : ""
            }
            ${generateNavLink({
              className: "F24_NewArrivals_W_Nav",
              text: data["New Arrivals"],
              dataLinkId: ["women", "shop-more", "new-arrivals"],
              href: "/c/womens/new-arrivals",
            })}
            ${generateNavLink({
              className: "s24_gifts_for_her",
              text: data["Gifts for Her"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "gifts-for-her"],
              href: "/c/womens/gifts-for-her/wid-o9ge1z7j",
            })}
            ${generateNavLink({
              className: "ski-and-snowboard-gear-guide",
              text: data["Best Sellers"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "ski-and-snowboard-collection"],
              href: "/c/womens/best-sellers/wid-dlk87r1l",
            })}
            ${generateNavLink({
              className: "grottoflage",
              text: "Grottoflage",
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "grottoflage"],
              href: "/c/womens/grottoflage/wid-p9p17dg9",
            })}
            ${generateNavLink({
              className: "F24_BackInStock_W_Nav",
              text: data.Exclusives,
              dataLinkId: ["women", "shop-more", "exclusives"],
              href: "/c/womens/back-in-stock/wid-ojd1gwnj",
            })}
            ${generateNavLink({
              className: "whats-your-warmest",
              text: data["What's Your Warmest"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "whats-your-warmest"],
              href: "/c/womens/whats-your-warmest/wid-1jwrp2ml",
            })}
            ${generateNavLink({
              className: "f23_shellfinder",
              text: data["$^nav-shellFinder^$"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "shell-finder"],
              href: "/shop/jacket-finder/womens",
            })}
            ${generateNavLink({
              className: "f23_footwear_finder",
              text: data["$^nav-footwearFinder^$"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "footwear-finder"],
              href: "/shop/footwear-finder",
            })}
            ${generateNavLink({
              className: "layering-guide",
              text: data["$^nav-layering-guide^$"],
              dataPrefix: "women",
              dataLinkId: ["women", "shop-more", "layering-guide"],
              href: "/shop/womens-layering-guide",
            })}
            ${generateNavLink({
              className: "F24_Travel_W_Nav",
              text: data["$^nav-travelCollection^$"],
              dataLinkId: ["women", "shop-more", "travel-collection"],
              href: "/shop/womens-travel-collection",
            })}
            ${
              isLunarNewYearEnabled()
                ? generateNavLink({
                    className: "lunar-new-year",
                    text: data["Year of the Dragon Capsule"],
                    dataPrefix: "women",
                    dataLinkId: ["women", "shop-more", "lunar-new-year"],
                    href: "/shop/lunar-new-year",
                  })
                : ""
            }
        </div>
    </ul>
`;

const womensShoppingCategoryMenusFdp = (data, country) => `
    ${womensClothingMenu(data)}
    <div class="group">
    ${womensPacksMenu(data)}
    ${womensFootwearMenu(data)}
    </div>
    <div class="group">
    ${womensAccessoriesMenu(data)}
    ${womensClimbingMenu(data)}
    </div>
    <div class="nav-item__divider"></div>
    <div class="group">
        ${womenActivityEvolutionClimb(data)}
        ${womenActivityEvolutionTrail(data)}
        ${womenActivityEvolutionSki(data)}
    </div>
    <div class="nav-item__divider"></div>
    ${womensCollectionsMenu(data)}
    <div class="nav-item__divider"></div>
    ${womensShopMoreMenu(data, country)}

`;

export const womensShoppingCategoryMenu = (data, country) => womensShoppingCategoryMenusFdp(data, country);
